import React, { useEffect, useState } from 'react'
import parseJson from 'parse-json'
import { join, groupBy, trimEnd, difference } from 'lodash'
import Box from '@material-ui/core/Box'
import { useTranslation } from 'react-i18next'
import { useDateFnsLocale } from 'src/hooks'
import { WEEK_LIST } from 'src/utils/constant'

const FormatWeekAvailableDate = (props) => {
  const { t } = useTranslation()
  const { formatWeek } = useDateFnsLocale()
  const [availableTime, setAvailableTime] = useState(null)
  const [breakDays, setBreakDays] = useState([])
  useEffect(() => {
    let availableTimeObj = null
    try {
      availableTimeObj = parseJson(props.availableTime)
    } catch (error) {}
    let availableTimeList = []
    const daysOfWeek = Object.keys(availableTimeObj || {})
    setBreakDays(join(difference(WEEK_LIST, daysOfWeek), '，'))
    for (const key in availableTimeObj) {
      if (Object.hasOwnProperty.call(availableTimeObj, key)) {
        const element = availableTimeObj[key]
        availableTimeList.push({ week: key, time: join(element, '、') })
      }
    }
    const groupAvailableTimeList = groupBy(availableTimeList, 'time')
    let finalList = []
    for (const key in groupAvailableTimeList) {
      if (Object.hasOwnProperty.call(groupAvailableTimeList, key)) {
        const groupItem = groupAvailableTimeList[key]
        let timeString = ''
        groupItem.forEach((item) => {
          timeString += `${item.week}，`
        })
        finalList.push({ weeks: trimEnd(timeString, '，'), times: key })
      }
    }
    setAvailableTime(finalList)
  }, [props.availableTime])

  /**
   * add locale for week string format
   *
   * @param {string} weekStr
   */
  const formatWeekStr = (weekStr) =>
    weekStr
      ?.split('，')
      ?.map((week) => formatWeek(week))
      ?.join('、')

  return availableTime?.length ? (
    <>
      {availableTime.map((date, index) => (
        <Box key={date.weeks}>
          【{formatWeekStr(date.weeks)}】{date.times}
        </Box>
      ))}
      {breakDays ? (
        <Box>
          【{formatWeekStr(breakDays)}】{t('glossary.day_off')}
        </Box>
      ) : null}
      {props.holiday ? (
        <Box>
          【{t('glossary.public_holiday')}】{t('glossary.day_off')}
        </Box>
      ) : null}
    </>
  ) : null
}

export default FormatWeekAvailableDate
